import axioscep from "axios";
import { Event } from "../Event";
import axios from "./../../utilities/axios";

export class CompanyZipCodeEvents extends Event {
  public onBlur = async (value: any, setField: any, setState: any) => {
    if (value) {
      setState("loadings", [
        "company_street",
        "company_district",
        "company_fk_state_id",
        "company_fk_city_id",
      ]);

      let addressData: any;
      let labelValue: any;

      await axioscep
        .get("https://viacep.com.br/ws/" + value + "/json/")
        .then((data: any) => {
          addressData = data.data;
          this.setFieldValue("company_street", addressData.logradouro);
          this.setFieldValue("company_district", addressData.bairro);
          return addressData;
        })
        .catch((err: any) => {
          console.log("Valor do erro :::>> ", err);
          throw err;
        })
        .then(async () => {
          if (addressData) {
            await axios
              .get("/api/v1/states/select", {
                params: {
                  state: addressData.uf,
                },
              })
              .then((res: any) => {
                const { items } = res.data;
                const { label, value } = items[0] ?? {};

                this.setFieldValue("company_fk_state_id", {
                  label: label,
                  value: value,
                });

                labelValue = {
                  label: label,
                  value: value,
                };
              })
              .catch((err: any) => {
                console.log("Erro ao buscar estado :::>> ", err);
              });
          }
        })
        .catch((err: any) => {
          console.log("Erro no processamento final :::>> ", err);
        })
        .finally(async () => {
          await axios
            .get("/api/v1/cities/select", {
              params: {
                search: labelValue.label,
                state: labelValue.value,
              },
            })
            .then((res: any) => {})
            .finally(() => {
              setState("loadings", []);
            });

          setTimeout(() => {
            this.setState("loadings", []);
          }, 100);
        });
    }
  };
}
